<template>
  <div class="eventComp_mode_7 eventComp_mode_container" v-show="currThemeObj">
    <template v-if="tableData && tableData.length > 0">
      <span class="eventComp_mode_title" v-text="groupText"></span>
      <div class="teamInfo" v-show="baseInfoArr && baseInfoArr.length === 2">
        <div class="teamInfo_item home">
          <span
            class="groupInfor_name"
            v-text="_valPerFormatHandler(baseInfoArr[0].team_name)"
            @click="goDetail('CSMeetDelegationDetailIndex', baseInfoArr[0])"
          ></span>
          <span
            class="groupInfor_logo"
            :class="baseInfoArr[0].team_logo ? 'isLogo' : ''"
          >
            <img
              v-if="baseInfoArr[0].team_logo"
              :src="baseInfoArr[0].team_logo"
            />
          </span>
        </div>
        <div class="teamInfo_item away">
          <span
            class="groupInfor_logo"
            :class="baseInfoArr[1].team_logo ? 'isLogo' : ''"
          >
            <img
              v-if="baseInfoArr[1].team_logo"
              :src="baseInfoArr[1].team_logo"
            />
          </span>
          <span
            class="groupInfor_name"
            v-text="_valPerFormatHandler(baseInfoArr[1].team_name)"
            @click="goDetail('CSMeetDelegationDetailIndex', baseInfoArr[1])"
          ></span>
        </div>
      </div>
      <div
        class="dataContrast_row"
        v-for="rowData in tableData"
        :key="rowData.key"
      >
        <span class="per_container home">
          <span class="per_container_bg"></span>
          <span
            class="per_container_rate"
            :style="{ width: `${rowData[rowData.key + '_per'][0]}%` }"
          ></span>
        </span>
        <span class="dataContrast_text">
          <span
            class="homeVal"
            v-text="
              _valPerFormatHandler(
                rowData[rowData.key + '_val'][0],
                rowData.orginValIsRate ? '' : ''
              )
            "
          ></span>
          <span
            class="textVal"
            v-text="_valPerFormatHandler(rowData.textVal)"
          ></span>
          <span
            class="awayVal"
            v-text="
              _valPerFormatHandler(
                rowData[rowData.key + '_val'][1],
                rowData.orginValIsRate ? '' : ''
              )
            "
          ></span>
        </span>
        <span class="per_container away">
          <span class="per_container_bg"></span>
          <span
            class="per_container_rate"
            :style="{ width: `${rowData[rowData.key + '_per'][1]}%` }"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// 适用：篮球 球队对比
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_7',
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_7 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      baseInfoArr: null,
      tableData: null,
      groupTextArr: ['个人数据对比', '球队对比'],
    }
  },

  mounted() {
    this.init()
  },
  computed: {
    groupText() {
      let text = this.groupTextArr[1]
      if (this.competitorType) {
        if (this.competitorType === 'A') {
          text = this.groupTextArr[0]
        }
      }
      return text
    },
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        const keyArr = ['home', 'away']
        const perList = []
        let baseInfoArr = keyArr.map((key) => {
          let teamItem = {}
          teamItem.score = this.datas[key].score
          teamItem.team_name = this.datas[key].team_name
          teamItem.team_eng = this.datas[key].team_eng
          teamItem.team_id = this.datas[key].team_id
          teamItem.team_logo = this.datas[key].team_logo
          teamItem.is_win = this.datas[key].is_win
          perList.push(
            this.datas['competitorStats'] && this.datas['competitorStats'][key]
              ? this.datas['competitorStats'][key]
              : []
          )
          return teamItem
        })
        const table_head =
          this.datas['competitorStats'] &&
          this.datas['competitorStats'].table_head
            ? this.datas['competitorStats'].table_head
            : []

        let datas = table_head.map((keyItem) => {
          let perRowData = {}
          perRowData.textVal = keyItem.name
          perRowData.key = keyItem.map_key_arr[0]
          if (perRowData.key.indexOf('_rate') > 1) {
            // 原始值是否是百分比值
            perRowData.orginValIsRate = true
          } else {
            perRowData.orginValIsRate = false
          }

          perList.forEach((teamVal, teamIndex) => {
            if (teamIndex === 0) {
              perRowData[`${perRowData.key}_val`] = []
              perRowData[`${perRowData.key}_per`] = []
            }

            perRowData[`${perRowData.key}_val`].push(teamVal[perRowData.key])
            perRowData[`${perRowData.key}_per`].push(
              teamVal[`${perRowData.key}_per`]
            )

            // if (perRowData.orginValIsRate) {
            //   // 如果是百分比值则不需要计算，直接push
            //   perRowData[`${perRowData.key}_per`].push(teamVal[perRowData.key])
            // }
          })
          // console.debug("perList:", perList)
          // let valArr = perRowData[`${perRowData.key}_val`]
          // let valTotal = valArr[0] - 0 + (valArr[1] - 0)
          // let perArr = []
          // let homePer = 0
          // if (isNaN(valTotal)) {
          //   console.debug('计算错误，NaN')
          //   perArr = [0, 0]
          // } else if (valTotal === 0) {
          //   perArr = [0, 0]
          // } else {
          //   homePer = Math.round(((valArr[0] - 0) / valTotal) * 1000) / 10
          //   perArr = [homePer, (100 - homePer).toFixed(1)]
          // }
          // perRowData[`${perRowData.key}_per`] = perArr
          return perRowData
        })

        this.baseInfoArr = baseInfoArr
        console.debug('perList:', datas)
        this.computedModeData(datas)
      })
    },
    goDetail(routerName, item, id) {
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    notDataHandler() {
      this.tableData = []
    },
    computedModeData(data) {
      console.debug('computedModeData mode_7:', data)

      if (data.length > 0) {
        this.tableData = data
      } else {
        this.notDataHandler()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  width: 100%;
  height: auto;
  .eventComp_mode_title {
    display: block;
    font-size: 1.11vw;
    line-height: 2.788vw;
    font-weight: bold;
    color: var(--mixtmt_mainColor5);
  }
  .teamInfo {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: var(--mixtmt_table_headerBg);
    .teamInfo_item {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 3.47vw;
      .groupInfor_logo {
        width: 2.91vw;
        height: 1.94vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .groupInfor_name {
        width: auto;
        padding: 0 0.69vw;
        font-size: 1.11vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
      }
    }
  }
  .dataContrast_row {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    height: 3.194vw;
    padding: 0 2.788vw;
    .per_container {
      position: relative;
      width: calc(50% - 11.03vw);
      height: 3.194vw;
      &.home {
        .per_container_rate {
          right: 0;
          /* background-color: rgba(8, 198, 180, 1); */
          background-color: var(--mixtmt_combatBar1_1);
        }
      }
      &.away {
        .per_container_rate {
          left: 0;
          /* background-color: rgba(252, 172, 1, 1); */
          background-color: var(--mixtmt_combatBar1_2);
        }
      }
      .per_container_bg,
      .per_container_rate {
        display: block;
        position: absolute;
        top: 50%;
        height: 0.555vw;
        border-radius: 0.278vw;
        transform: translateY(-50%);
      }
      .per_container_bg {
        left: 0;
        z-index: 2;
        width: 100%;
        background-color: var(--mixtmt_greyColor7);
      }
      .per_container_rate {
        z-index: 5;
        width: 0;
        transition: width 0.3s linear;
      }
    }
    .dataContrast_text {
      width: 22.06vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      color: var(--mixtmt_greyColor3);
      .homeVal,
      .awayVal {
        width: calc(50% - 4.86vw);
        font-size: 1.11vw;
      }
      .homeVal {
        padding-right: 0.347vw;
        text-align: right;
      }
      .awayVal {
        padding-left: 0.347vw;
        text-align: left;
      }
      .textVal {
        width: 9.72vw;
        font-size: 1.11vw;
        text-align: center;
        font-weight: bold;
      }
    }
  }
}

.mixtmt_pc {
  .eventComp_mode_container {
    .teamInfo {
      .groupInfor_name {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
